import { jwtDecode } from 'jwt-decode';
import CONFIG from '../config/config';

export const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const decodedToken = jwtDecode(token);
    // Only check expiry if token has exp claim
    if (!decodedToken.exp) {
      // Token doesn't have expiry - assume valid (server will validate)
      return false;
    }
    const currentTime = Date.now() / 1000;
    return decodedToken.exp < currentTime;
  } catch (error) {
    // Token is not a JWT - that's OK, server will validate it
    // Don't treat non-JWT tokens as expired
    console.log('[AUTH] Token is not a JWT, skipping client-side expiry check');
    return false;
  }
};

export const checkAndRefreshToken = async () => {
  const token = localStorage.getItem('authToken');
  if (!token) return false;

  // Only refresh if token is actually expired or close to expiring
  try {
    const decoded = jwtDecode(token);

    // If token doesn't have exp claim, assume it's valid (server will validate)
    if (!decoded.exp) {
      return true;
    }

    const currentTime = Date.now() / 1000;
    const timeUntilExpiry = decoded.exp - currentTime;

    // If token is still valid for more than an hour, don't refresh
    if (timeUntilExpiry > 3600) {
      return true;
    }

    console.log('Token needs refresh, time until expiry:', timeUntilExpiry);

    const response = await fetch(`${CONFIG.API_URLS.AUTH.REFRESH_TOKEN}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      console.error('Token refresh failed:', await response.text());
      localStorage.removeItem('authToken');
      return false;
    }

    const { token: newToken } = await response.json();
    localStorage.setItem('authToken', newToken);
    return true;
  } catch (error) {
    // Token is not a JWT - that's OK, assume valid and let server validate
    console.log('[AUTH] Token is not a JWT, skipping refresh');
    return true;
  }
}; 